import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { PaginatedResponse } from '../../../../shared/interfaces/pagination';
import {
  CDFIOutreachEmail,
  CDFIOutreachLog,
} from '../models/cdfi-outreach-log';
import { CDFIOutreachStats } from '../models/cdfi-outreach-stats';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CdfiOutreachLogsService {
  private http: HttpClient = inject(HttpClient);

  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';

  getCdfiOutreachLogs(
    pageNo = 1,
    pageSize = 10,
    outreachType: number,
    filterBy?: number,
    searchQuery?: string,
    source?: string,
    lead_status?: number,
  ): Observable<PaginatedResponse<CDFIOutreachLog>> {
    let params = new HttpParams();
    params = params.set('page', pageNo.toString());
    params = params.set('page_size', pageSize.toString());
    params = params.set('outreach_type', outreachType.toString());

    if (searchQuery) {
      params = params.set('business_name', searchQuery);
    }

    if (filterBy !== undefined) {
      params = params.set('status', filterBy);
    }

    if (source) {
      params = params.set('source', source);
    }

    if (lead_status !== undefined) {
      params = params.set('lead_status', lead_status.toString());
    }

    return this.http.get<PaginatedResponse<CDFIOutreachLog>>(
      this.adminApiBaseUrl + '/cdfi-outreach',
      { params },
    );
  }

  getCdfiOutreachStats(
    outreachType: number,
    source?: string,
  ): Observable<CDFIOutreachStats> {
    let params = new HttpParams();
    params = params.set('outreach_type', outreachType.toString());

    if (source) {
      params = params.set('source', source);
    }

    return this.http.get<CDFIOutreachStats>(
      this.adminApiBaseUrl + '/cdfi-outreach/stats',
      { params },
    );
  }

  getCdfiOutreachEmailEvents(
    outreach_id: number,
  ): Observable<CDFIOutreachEmail> {
    return this.http.get<CDFIOutreachEmail>(
      this.adminApiBaseUrl + `/cdfi-outreach/${outreach_id}/email-events`,
      {
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }
}
